import { FC, useEffect, useState } from 'react';
import styled from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import Header from '@/components/XPower/elements/Header';
import MoreButton from '@/components/XPower/elements/MoreButton';
import { BoostIcon } from '@/components/XPower/svg';
import { SwitchIcon } from '@/components/XPower/svg';
import Video from '@/components/XPower/elements/Video';
import { EU_LIST } from '@/components/XPower/constants';
import getLocal from '@/app/utils/getLocal';

const XBoost: FC = () => {
    const { t } = useLang('xcode.xboost');
    const [status, setStatus] = useState(false);
    const { locale } = getLocal();

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const sceneA = AniContainer.create({
                // asyncFromTo: [[`.${styled.XBoost} .text_box`, { opacity: 0 }, { opacity: 1 }, 1]],
                onEnter: () => {
                    setStatus(true);
                },
                triggerElement: `.${styled.XBoost}`,
                triggerHook: 1,
                offset: '90%',
                duration: '30%',
            });
            AniContainer.scrollHandle(); //执行一次初始化
            return () => AniContainer.removeScene(sceneA);
        }
    }, []);

    let mediaList = [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719219373186/4.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719219398035/Mask%20group.jpg',
            text: t.rich('media.media_text1', {
                line: (text: string) => <span>{text}</span>,
            }),
        },
    ];

    if (EU_LIST.includes(locale)) {
        mediaList = [
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1724730444294/boost.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1724730457267/boost_m.jpg',
                text: t.rich('media.media_text2', {
                    line: (text: string) => <span>{text}</span>,
                }),
            },
        ];
        if (locale === 'uk') {
            mediaList[0].pc = 'https://websiteoss.ecoflow.com/upload/image/1724730471697/boost_uk.jpg';
            mediaList[0].h5 = 'https://websiteoss.ecoflow.com/upload/image/1724730483120/boost_ukm.jpg';
        }
    }

    return (
        <div className={styled.XBoost}>
            <Header icon={<BoostIcon />} desc={t('title')} subtitle={t('subtitle')} />
            <div className="middle-central">
                <div className="text_box">
                    <div className="left font-desc">
                        {t.rich('text.left', {
                            line: (text: string) => <span>{text}</span>,
                        })}
                    </div>
                    <div className="right font-desc">
                        <div className="right_item">
                            <SwitchIcon className={`btn ${status ? 'open' : 'close'}`} onClick={() => setStatus(!status)} />
                            <span>{t('text.right_btn')}</span>
                        </div>
                        <div className="right_item">
                            <div>
                                <p className="font-desc">{t('text.right_up')}</p>
                                <div className="right_kw">
                                    <span className="num" style={{ transform: `translateY(${status ? '-200%' : '0'})` }}>
                                        <span>4</span>
                                        <span>5</span>
                                        <span>6</span>
                                    </span>
                                    <span className='pre_space'>{t('text.right_kw')}</span>
                                </div>
                                <p className="font-desc">{t('text.right_supports')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="big-central media_box">
                <Video src="https://ecoflow-service-us-cdn.ecoflow.com/upload/video/1718951097681/%E6%9C%AA%E5%91%BD%E5%90%8D.mp4" />
            </div>

            <MoreButton text={t('btn_more')} mediaList={mediaList} />
        </div>
    );
};

export default XBoost;
